import {
  Collapse,
  Stack,
  Group,
  Text,
  Badge,
  Tooltip,
  Button,
  Title,
  Box,
  Paper,
} from "@mantine/core";
import { IconX, IconHome } from "@tabler/icons-react";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import tripsService from "../../services/trips.service";
import { ActionFunc, getTripTimeline, TripTimelineItem } from "./helper";
import { convertConstantLiteralToNormal } from "../../utils/string.helpers";
import TripInfoPanelTimelineItem from "./TripInfoPanelTimelineItem";
import IdentifyStopPanel from "../IdentifyStopPanel/IdentifyStopPanel";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezonePlugin from "dayjs/plugin/timezone";
import {
  CourierResponse,
  TripResponse,
  VehicleTripResponse,
} from "types/trip.types";
import TripsListPanel from "./TripsListPanel";
import TripDetailsPanel from "./TripDetailsPanel";
import { useSelector } from "react-redux";
import { RootState } from "store";
import EventRegistry from "utils/eventRegistry";
dayjs.extend(utc);
dayjs.extend(timezonePlugin);

interface TripInfoPanelProps {
  vehiclerips?: VehicleTripResponse[];
  unassignedTrips?: TripResponse[];
  currentUnassignedTripId?: number;
  currentTripId?: number;
  timezone?: string;
  adminMode?: boolean;
  eventRegistry?: EventRegistry;
  onAction?: ActionFunc;
  date?: Date;
  displayDetails?: boolean;
  loading?: boolean;
}

export function TripInfoPanel({
  vehiclerips,
  unassignedTrips,
  currentUnassignedTripId,
  timezone,
  adminMode,
  currentTripId,
  eventRegistry,
  onAction,
  date,
  displayDetails,
  loading,
}: TripInfoPanelProps) {
  // const [displayDetails, setDisplayDetails] = useState(false);
  const currentTrip = useSelector((state: RootState) =>
    state.trips.trips?.find((t) => t.vehicleTripId == currentTripId)
  );

  const PANEL_WIDTH = 420;
  const SEARCH_WIDTH = 430;

  // useEffect(() => {
  //   setTripId(currentTripId);
  // }, [currentTripId]);

  const handleActions = (action: string, params: any) => {
    switch (action) {
      case "set-current-trip":
        // setDisplayDetails(false);
        onAction && onAction("set-trip-id", { tripId: params.tripId });
        break;
      // case "set-tripId-to-display-details":
      //   setDisplayDetails(true);
      //   break;
      default:
        onAction && onAction(action, params);
    }
  };

  return currentTrip && displayDetails ? (
    <TripDetailsPanel
      vehicleTrip={currentTrip}
      onAction={handleActions}
      eventRegistry={eventRegistry}
      adminMode={adminMode}
    />
  ) : (
    <TripsListPanel
      vehicleTrips={vehiclerips ?? []}
      unassignedTrips={unassignedTrips}
      currentUnassignedTripId={currentUnassignedTripId}
      timezone={timezone}
      onAction={handleActions}
      currentTripId={currentTripId}
      eventRegistry={eventRegistry}
      date={date}
      adminMode={adminMode}
      loading={loading}
    />
  );

  // onParkingChangRef.current = () => {
  //   if (trip) {
  //     const tripParkings = tripsService.LocationsPathService.getTripParkings(
  //       trip.tripId ?? 0
  //     );
  //     setTimeline(
  //       getTripTimeline(trip, tripParkings, displayComputed, parkingId)
  //     );
  //   }
  // };

  // const onParkingChanged = () => {
  //   if (onParkingChangRef.current) onParkingChangRef.current();
  // };

  // const closeStopIdentify = () => {
  //   setStopToIdentifyIndex(undefined);
  //   setStopIdentifyTitle("");
  //   handleActions("map-clear-markers");
  // };
  // const handleClose = () => {
  //   if (stopToIdentifyIndex != undefined) {
  //     closeStopIdentify();
  //   } else {
  //     if (onClose) onClose();
  //   }
  // };

  // const handleActions = (action: string, params?: any) => {
  //   switch (action) {
  //     case "title-change":
  //       break;
  //     case "identify-stop":
  //       setStopToIdentifyIndex(params);
  //       setStopIdentifyTitle(
  //         `${timeline[params].location.latitude}, ${timeline[params].location.longitude}`
  //       );
  //       if (onAction)
  //         onAction("map-focus", {
  //           lat: timeline[params].location.latitude,
  //           lng: timeline[params].location.longitude,
  //         });
  //       break;
  //     case "identify-stop-type":
  //       const item = params.item ?? timeline.find((t) => t.id == params.stopId);
  //       if (item?.info.vehicleStopId) {
  //         const { type, purpose, additionalData } = params;
  //         VehiclesService.identifyVehicleStop(
  //           item.info.vehicleStopId ?? 0,
  //           type,
  //           purpose,
  //           additionalData
  //         ).then((data) => {
  //           if (data && onAction) {
  //             onAction("set-parking-additional-data", {
  //               tripParkingId: item.id,
  //               type,
  //               purpose,
  //               tripId: trip?.tripId,
  //             });
  //           }
  //         });
  //       }
  //       closeStopIdentify();
  //       break;
  //     case "set-highligh-stop":
  //       if (onAction && trip && params < trip?.tripStops.length) {
  //         const stopId = trip.tripStops[params].tripStopId;
  //         onAction("set-highligh-stop", stopId);
  //         onAction("map-focus", {
  //           lat: trip.tripStops[params].location.latitude,
  //           lng: trip.tripStops[params].location.longitude,
  //           zoom: 10,
  //         });
  //       }
  //       break;
  //     case "unset-highligh-stop":
  //       if (onAction) {
  //         onAction("set-highligh-stop", undefined);
  //       }
  //       break;
  //     case "get-trip-stops":
  //       return trip?.tripStops;
  //     default:
  //       if (onAction) onAction(action, params);
  //   }
  // };

  // function refreshRefs() {
  //   const itemElements: any[] =
  //     timelineRef.current?.querySelectorAll(".trip-stops-timeline-item") ?? [];
  //   itemElements.forEach((element, idx) => {
  //     timeline[idx].ref = element;
  //     if (timeline[idx].focused) {
  //       element.scrollIntoView({
  //         behavior: "smooth",
  //         block: "nearest",
  //       });
  //     }
  //   });
  // }

  // useEffect(() => {
  //   closeStopIdentify();
  //   if (trip) {
  //     setCourier(couriers?.find((c) => c.courierId == trip.courierId));
  //     const tripParkings = tripsService.LocationsPathService.getTripParkings(
  //       trip.tripId ?? 0
  //     );

  //     setTimeline(
  //       getTripTimeline(trip, tripParkings, displayComputed, parkingId)
  //     );

  //     const tCost = tripParkings.reduce((total, p, pIdx) => {
  //       if (pIdx < tripParkings.length) {
  //         return (
  //           total +
  //           (p.additionalData?.dwellCost ?? 0) +
  //           (p.additionalData?.transitShareCost ?? 0)
  //         );
  //       } else {
  //         return total;
  //       }
  //     }, 0);
  //     const totalAllocated = tripParkings.reduce((total, p, pIdx) => {
  //       if (pIdx < tripParkings.length) {
  //         return total + (p.additionalData.allocatedCost ?? 0);
  //       } else {
  //         return total;
  //       }
  //     }, 0);
  //     setTotalAllocatedPrecent(Math.round((totalAllocated / tCost) * 100));
  //     setTotalCost(tCost);
  //     setTotalMiles(
  //       displayComputed
  //         ? (trip.computedMiles ?? 0) + (trip.computedReturnMiles ?? 0)
  //         : trip.totalMiles ?? 0
  //     );
  //   } else {
  //     setCourier(undefined);
  //     setTimeline([]);
  //     setTotalCost(0);
  //     setTotalMiles(0);
  //   }
  // }, [trip, displayComputed]);

  // useEffect(() => {
  //   tripsService.LocationsPathService.registerOnChange(
  //     `TRIPS.INFOPANEL`,
  //     onParkingChanged
  //   );
  //   return () => {
  //     tripsService.LocationsPathService.unRegisterOnChange(`TRIPS.INFOPANEL`);
  //   };
  // }, []);

  // useLayoutEffect(() => {
  //   refreshRefs();
  // }, [timeline]);

  // useEffect(() => {
  //   if (
  //     !timeline.length ||
  //     (stopNumber == undefined && parkingId == undefined)
  //   ) {
  //     return;
  //   }

  //   let pIndex = 0;
  //   if (parkingId) {
  //     pIndex = timeline.findIndex((t) => t.id === parkingId);
  //   } else if (stopNumber) {
  //     pIndex = timeline.findIndex((t) => t.stopNumber == stopNumber);
  //   }

  //   if (pIndex < 0) {
  //     pIndex = 0;
  //   }
  //   if (pIndex >= 0) {
  //     if (timelineRef.current) {
  //       const itemElements: any[] =
  //         timelineRef.current.querySelectorAll(".focused");
  //       itemElements.forEach((element) => {
  //         element.classList.remove("focused");
  //       });
  //       if (timeline[pIndex].ref) {
  //         timeline[pIndex].ref.classList.add("focused");
  //         timeline[pIndex].ref.scrollIntoView({
  //           behavior: "smooth",
  //           block: "nearest",
  //         });
  //       }
  //     }
  //   }
  //   timelineDateRef.current = dayjs(trip?.assignedAt);
  // }, [parkingId, stopNumber, timeline]);

  // if (timezone) dayjs.tz.setDefault(timezone);

  // return (
  //   <Collapse
  //     in={Boolean(trip)}
  //     transitionDuration={200}
  //     orientation="horizontal"
  //   >
  //     <Box className="trip-info-panel-container" style={{ display: "flex" }}>
  //       <Box
  //         className="width-provider"
  //         style={{
  //           width:
  //             (stopToIdentifyIndex !== undefined
  //               ? PANEL_WIDTH + SEARCH_WIDTH
  //               : PANEL_WIDTH) + 1,
  //         }}
  //       />
  //       <Paper
  //         className="trip-info-panel"
  //         radius="md"
  //         shadow="sm"
  //         withBorder
  //         style={{ flex: 1, minWidth: PANEL_WIDTH }}
  //       >
  //         <Stack spacing={0} style={{ height: "100%" }}>
  //           <Group
  //             align="center"
  //             px="md"
  //             py="xs"
  //             style={{ borderBottom: "1px solid #eee" }}
  //           >
  //             <Stack gap={0} style={{ flex: 1 }}>
  //               <Title order={5}>
  //                 {courier?.firstName} {courier?.lastName}
  //               </Title>
  //               <Group gap="xs">
  //                 <Tooltip
  //                   label={
  //                     trip?.vehicle?.externalId
  //                       ? `ID: ${trip.vehicle.externalId} (${trip.vehicleId})`
  //                       : trip?.vehicleId
  //                       ? "#" + trip.vehicleId
  //                       : ""
  //                   }
  //                   withArrow
  //                   position="right"
  //                 >
  //                   <Text size="sm" c="dimmed">
  //                     {trip?.vehicle?.vehicleType} {trip?.vehicle?.licensePlate}
  //                   </Text>
  //                 </Tooltip>
  //                 <Badge size="sm" color="gray" variant="light">
  //                   {convertConstantLiteralToNormal(trip?.status ?? "")}
  //                 </Badge>
  //               </Group>
  //               <Group gap="xs" mt={2}>
  //                 {Boolean(totalCost) && (
  //                   <Text size="xs" c="dimmed">
  //                     Total Cost: ${totalCost.toFixed(0)} (
  //                     {totalAllocatedPrecent}% allocated)
  //                   </Text>
  //                 )}
  //                 {Boolean(totalMiles) && (
  //                   <Text size="xs" c="dimmed">
  //                     {totalMiles.toFixed(0)} Miles
  //                   </Text>
  //                 )}
  //               </Group>
  //             </Stack>
  //             <Stack gap={0} style={{ flex: 1 }}>
  //               {stopToIdentifyIndex !== undefined && (
  //                 <Stack gap={0}>
  //                   <Text size="xs" c="dimmed">
  //                     Identify Stop
  //                   </Text>
  //                   <Text size="sm">{stopIdentifyTitle}</Text>
  //                 </Stack>
  //               )}
  //             </Stack>
  //             <Button
  //               variant="subtle"
  //               color="gray"
  //               size="xs"
  //               px={4}
  //               onClick={handleClose}
  //               style={{ alignSelf: "flex-start" }}
  //             >
  //               <IconX size={18} />
  //             </Button>
  //           </Group>
  //           <Group
  //             align="flex-start"
  //             spacing={0}
  //             style={{ flex: 1, height: "100%", overflow: "hidden" }}
  //           >
  //             <Box
  //               style={{
  //                 width: PANEL_WIDTH,
  //                 overflowY:
  //                   stopToIdentifyIndex !== undefined ? "hidden" : "auto",
  //                 position: "relative",
  //                 height: "100%",
  //               }}
  //               className="trip-stops-timeline-wrapper"
  //             >
  //               <Box
  //                 className="cover"
  //                 style={{
  //                   width: PANEL_WIDTH,
  //                   display:
  //                     stopToIdentifyIndex !== undefined ? "block" : "none",
  //                   position: "absolute",
  //                   top: 0,
  //                   left: 0,
  //                   height: "100%",
  //                   zIndex: 2,
  //                   background: "rgba(255,255,255,0.5)",
  //                 }}
  //               />
  //               <Box p="xs" style={{ position: "relative", height: "100%" }}>
  //                 <Stack
  //                   ref={timelineRef}
  //                   gap={0}
  //                   className="trip-stops-timeline"
  //                 >
  //                   {timeline.map((item, index) => {
  //                     const displayDate = !timelineDateRef.current?.isSame(
  //                       dayjs(item.arrival),
  //                       "day"
  //                     );
  //                     if (displayDate) {
  //                       timelineDateRef.current = dayjs(item.arrival);
  //                     }
  //                     return (
  //                       <TripInfoPanelTimelineItem
  //                         item={item}
  //                         itemIndex={index}
  //                         colorIndex={colorIndex}
  //                         displayDate={displayDate}
  //                         onAction={handleActions}
  //                         blur={
  //                           stopToIdentifyIndex != undefined
  //                             ? stopToIdentifyIndex != index
  //                             : undefined
  //                         }
  //                         adminMode={adminMode}
  //                         key={index}
  //                       />
  //                     );
  //                   })}
  //                   {displayComputed && (
  //                     <Group justify="center" align="end" mt={8} mb={16}>
  //                       <IconHome color="silver" size={18} />
  //                       <Text size="xs" c="dimmed">
  //                         {trip?.computedReturnAt
  //                           ? dayjs(trip.computedReturnAt).format(
  //                               "MM/DD h:mm a"
  //                             )
  //                           : ""}
  //                       </Text>
  //                     </Group>
  //                   )}
  //                 </Stack>
  //               </Box>
  //             </Box>
  //             {stopToIdentifyIndex !== undefined && (
  //               <Box
  //                 style={{
  //                   width: SEARCH_WIDTH,
  //                   height: "100%",
  //                   overflowY: "auto",
  //                   scrollbarWidth: "thin",
  //                 }}
  //               >
  //                 <IdentifyStopPanel
  //                   stopId={timeline[stopToIdentifyIndex].id}
  //                   location={timeline[stopToIdentifyIndex].location}
  //                   onAction={handleActions}
  //                 />
  //               </Box>
  //             )}
  //           </Group>
  //         </Stack>
  //       </Paper>
  //     </Box>
  //   </Collapse>
  // );
}
